export enum BusEventSessionEnum {
  // Refresh token (RT)
  ASKING_BEFORE_END = 'ASKING_BEFORE_END',
  ASKING_RECONNECT = 'ASKING_RECONNECT',
  ASKING_SESSION_EXPIRED = 'ASKING_SESSION_EXPIRED',
}
